import React, { useCallback, useEffect, useState } from "react";
import { Form, Input, Row, Col, Modal, Button } from "antd";

import { Container } from "./styles";
import { openNotification } from "../../../../../../components/Notification";
import { useWidth } from "../../../../../../hooks";
import { frequenciaService } from "../../../../../../services/resources/frequenciaService";
import TextArea from "antd/lib/input/TextArea";

export function ModalAdd({ onClose, mode, codigo, reload }) {
  const [form] = Form.useForm();
  const { width } = useWidth();

  const [loading, setLoading] = useState(false);

  const [frequencia, setFrequencia] = useState([]);

  const handleCloseModal = useCallback(() => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    async function getfrequencia() {
      try {
        const { data } = await frequenciaService.get(codigo);

        setFrequencia(data);
        form.setFieldsValue({
          descricao: data?.descricao,
          fundamentacao: data?.fundamentacao,
        });
      } catch (error) {
        openNotification(
          "error",
          <strong>Erro!</strong>,
          error?.response?.data?.detail
        );
      }
    }
    if (mode !== "onCreate") {
      getfrequencia();
    }
  }, [codigo, mode, form]);

  async function create() {
    try {
      setLoading(true);
      await frequenciaService.create(form.getFieldsValue());
      handleCloseModal();
      openNotification(
        "success",
        <strong>Frequência adicionada com sucesso!</strong>
      );
      reload();
    } catch (error) {
      handleCloseModal();
      openNotification(
        "error",
        <strong>Não foi possível criar a frequência!</strong>,
        error?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  }

  async function edit() {
    try {
      setLoading(true);
      await frequenciaService.edit(codigo, form.getFieldsValue());
      handleCloseModal();
      openNotification("success", <strong>Frequência editada!</strong>);
      reload();
    } catch (error) {
      handleCloseModal();
      openNotification(
        "error",
        <strong>Não foi possível editar a frequência!</strong>,
        error?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  }

  const footer = [
    mode === "onCreate" && (
      <Button key="submit" onClick={create} type="primary" loading={loading}>
        cadastrar
      </Button>
    ),
    mode === "onEdit" && (
      <Button
        key="submitUpdate"
        onClick={edit}
        type="primary"
        loading={loading}
      >
        atualizar
      </Button>
    ),
  ];

  return (
    <Modal
      title={
        (mode === "onCreate" && "NOVA FREQUÊNCIA") ||
        (mode === "onEdit" && `EDITAR FREQUÊNCIA - ${frequencia?.descricao}`) ||
        (mode === "onView" &&
          `DETALHES DA FREQUÊNCIAS - ${frequencia?.descricao}`)
      }
      width={width > 1280 ? "50vw" : "100vw"}
      onCancel={onClose}
      visible
      footer={footer}
      centered
    >
      <Container>
        <Form form={form} name="frequencia" layout="vertical">
          <Row>
            <Col span={24}>
              <Form.Item name="descricao" label={<span>Descrição:</span>}>
                <Input
                  type="text"
                  placeholder="insira a descrição"
                  autoComplete="none"
                  disabled={mode === "onView"}
                />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                <Form.Item
                  name="fundamentacao"
                  label={<span>Fundamentação:</span>}
                >
                  <TextArea
                    autoSize
                    placeholder="Digite a fundamentação da frequência"
                    disabled={mode === "onView"}
                  />
                </Form.Item>
              </Col>
          </Row>
        </Form>
      </Container>
    </Modal>
  );
}
